module.exports = new __parcel__URL__("fish.91063cf4.svg").toString();